export const LIKE_TOGGLE = 'LIKE_TOGGLE'
export const SET_NEW_LIKE = 'SET_NEW_LIKE'
export const DELETE_NEW_LIKE = 'DELETE_NEW_LIKE'
export const LIKE_UPDATE = 'LIKE_UPDATE'
export const RESET_LIKES_ACTION = 'RESET_LIKES_ACTION'
// Mutations
export const MERGE_POST_SOURCE = 'MERGE_POST_SOURCE'
export const SAVE_NEW_LIKE = 'SAVE_NEW_LIKE'
export const DELETE_LIKE = 'DELETE_LIKE'
export const RESET_LIKES = 'RESET_LIKES'



// WEBPACK FOOTER //
// ./src/store/actions/likesQueries.js